import { render, staticRenderFns } from "./onlineErp.vue?vue&type=template&id=bc57e8d4&scoped=true"
import script from "./onlineErp.vue?vue&type=script&lang=js"
export * from "./onlineErp.vue?vue&type=script&lang=js"
import style0 from "./onlineErp.vue?vue&type=style&index=0&id=bc57e8d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc57e8d4",
  null
  
)

export default component.exports